export interface UseSectorScrollSpyReturn {
  activeId: string
  hoverId: string | null
  setHoverId: React.Dispatch<React.SetStateAction<string | null>>
  sectorRefs: React.MutableRefObject<Record<string, HTMLElement | null>>
  handleClick: (id: string) => void
}

export const contents = [
  {
    id: "0",
    icon_link: "/assets/icons/saas.svg",
    title: "SAAS Development",
    description:
      "Our company specializes in SaaS (Software as a Service) development, crafting innovative and scalable solutions tailored to meet the unique needs of businesses across various industries.",
  },
  {
    id: "1",
    icon_link: "/assets/icons/livestream.svg",
    title: "Live Streaming",
    description:
      "At our company, we are at the forefront of live streaming technology, empowering businesses to engage and connect with their audiences in real-time.",
  },
  {
    id: "2",
    icon_link: "/assets/icons/iot.svg",
    title: "Digital Marketplace",
    description:
      "Embracing the digital era, our company is dedicated to facilitating seamless digital transformation journeys for organizations seeking to modernize their operations and stay ahead in today's competitive landscape.",
  },

  {
    id: "3",
    icon_link: "/assets/icons/social.svg",
    title: "Social Platform",
    description:
      "Our company is dedicated to building vibrant and inclusive social platforms that foster meaningful connections and community engagement.",
  },
  {
    id: "4",
    icon_link: "/assets/icons/handshake.svg",
    title: "End to End Business Solution",
    description:
      "Our company provides end-to-end business solutions designed to address the diverse needs and challenges of modern enterprises.",
  },
]

export const desktopContent = [
  {
    id: "0",
    iconDefault: "/assets/icons/saas-development.svg",
    iconHover: "/assets/icons/hover-saas-development.svg",
    iconActive: "/assets/icons/active-saas-development.svg",
    title: "SAAS Development",
  },
  {
    id: "1",
    iconDefault: "/assets/icons/live-stream.svg",
    iconHover: "/assets/icons/hover-livestream.svg",
    iconActive: "/assets/icons/active-livestream.svg",
    title: "Live Streaming",
  },
  {
    id: "2",
    iconDefault: "/assets/icons/digital-transformation.svg",
    iconHover: "/assets/icons/hover-digital-transformation.svg",
    iconActive: "/assets/icons/active-digital-transformation.svg",
    title: "Digital Transformation",
  },
  {
    id: "3",
    iconDefault: "/assets/icons/social-platform.svg",
    iconHover: "/assets/icons/hover-social-platform.svg",
    iconActive: "/assets/icons/active-social-platform.svg",
    title: "Social Platform",
  },
  {
    id: "4",
    iconDefault: "/assets/icons/end-to-end-business-solution.svg",
    iconHover: "/assets/icons/hover-end-to-end-business-solution.svg",
    iconActive: "/assets/icons/active-end-to-end-business-solution.svg",
    title: "End to End Business Solution",
  },
]
